import { render, staticRenderFns } from "./Bubbles.vue?vue&type=template&id=00a2bae9&"
import script from "./Bubbles.vue?vue&type=script&lang=ts&"
export * from "./Bubbles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports